import React from 'react';
import { Link } from 'react-router-dom';
import { formatDistanceToNowStrict } from 'date-fns';
import EntitlementIcon from '@css-xp/base/entitlement-icon';
import './widget-items.scss';
import Tooltip from '@atlaskit/tooltip';

interface SubscriptionWidgetItemType {
  url: string;
  timestamp: number;
  metadata?: {
    productId: string | null;
    productName: string;
    cloudSiteHostname: string;
  };
  entityName?: string;
}
/**
 * Component for Subscription Widget on the Search page
 * @constructor
 */
const SubscriptionWidgetItemsComponent = ({ url, timestamp, metadata }: SubscriptionWidgetItemType) => {
  return (
    <div className="flex justify-space-between pv-12 subscription-widget-item">
      <div className="left-side">
        <div className="content">
          <Link to={url}>
            <div className="flex">
              <EntitlementIcon productId={metadata?.productId ?? ''} isCloud={true} className="avatar medium" />
              <Tooltip content={metadata?.productName} position="bottom-start" tag="span">
                <div className="title" style={{ marginLeft: '5px' }}>
                  {metadata?.productName}
                </div>
              </Tooltip>
            </div>
          </Link>
        </div>
        <div className="content">
          <div className="sub-title" style={{ marginLeft: '30px' }}>
            {metadata?.cloudSiteHostname}
          </div>
        </div>
      </div>
      <div className="right-side">
        <div className="content">
          <div className="timestamp">{formatDistanceToNowStrict(new Date(timestamp), { addSuffix: true })}</div>
        </div>
      </div>
    </div>
  );
};

export const SubscriptionWidgetItem = React.memo(SubscriptionWidgetItemsComponent);
